import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ActivityFeed from "../../activity/ActivityFeed";
import { focusRing } from "../../workspaces/WorkspaceUi";

// Console → Activity: who changed what, and when, across the whole instance.
// Support reads it like any other bpExperts read; a workspace's own admins see
// their workspace under Manage workspace instead.
export default function ActivityPage() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, ...focusRing }}>
      <Stack sx={{ mb: 2.5 }}>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>
          Activity
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Every sign-in, invitation, role, key and setting, newest first. Nothing here can be changed - it is a record of what happened.
        </Typography>
      </Stack>
      <ActivityFeed scope="platform" />
    </Box>
  );
}
